<template>
  <MoreOptionsMenuButton
    v-bind="attrs"
    v-if="
      currentUser?.hasPermission('chits.change_chit') ||
      currentUser?.hasPermission('chits.download_chit') ||
      currentUser?.hasPermission('chits.delete_chit')
    "
  >
    <template #button="props" v-if="useFullBtn">
      <v-btn
        v-bind="props"
        :loading="loading"
        :disabled="disabled"
        class="text-capitalize"
        append-icon="mdi-menu-down"
        variant="outlined"
      >
        More Options
      </v-btn>
    </template>

    <v-list-item
      v-if="currentUser.hasPermission('chits.download_chit')"
      @click="emit('export-chit-pdf-pressed')"
      title="Export Chit as PDF"
    >
      <template #prepend>
        <v-icon size="18" icon="mdi-file" class="me-1" />
      </template>
    </v-list-item>

    <template v-if="state != ChitState.Approved">
      <v-list-item
        v-if="currentUser.hasPermission('chits.change_chit')"
        @click="emit('edit-chit-pressed')"
        title="Edit Chit"
      >
        <template #prepend>
          <v-icon size="18" icon="mdi-pencil" class="me-1" />
        </template>
      </v-list-item>

      <template v-if="currentUser.hasPermission('chits.delete_chit')">
        <v-divider class="pb-1" />
        <v-list-item class="text-error" @click="emit('delete-chit-pressed')" title="Delete Chit">
          <template #prepend>
            <v-icon size="18" icon="mdi-delete" class="me-1" />
          </template>
        </v-list-item>
      </template>
    </template>
  </MoreOptionsMenuButton>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
import { storeToRefs } from 'pinia'

import { useAuthStore } from '@/stores'
import { ChitState } from '@/models/chit'

import MoreOptionsMenuButton from '../common/MoreOptionsMenuButton.vue'

interface Props {
  useFullBtn?: boolean
  loading?: boolean
  disabled?: boolean
  state?: ChitState
}

defineProps<Props>()

interface Emit {
  (e: 'export-chit-pdf-pressed'): void
  (e: 'edit-chit-pressed'): void
  (e: 'delete-chit-pressed'): void
}
const emit = defineEmits<Emit>()

const attrs = useAttrs()

const authStore = useAuthStore()
const { getUser: currentUser } = storeToRefs(authStore)
</script>
